export default {
  methods: {
    mixCalcularAnticipoFinanciado() {
      const {
        importeCostoFinanciero,
        esEstimacionFiniquito,
      } = this.estimacion;

      let porcentajeAvanceFinancieroAcumuladoSinConvenio = this.$numberRoundDigits(
        (this.importeEstimadoActual
        / this.importeContrato), 4,
      );
      // Si el avance financiero acumulado es mayor a 1, se asigna 1
      if (porcentajeAvanceFinancieroAcumuladoSinConvenio > 1) {
        porcentajeAvanceFinancieroAcumuladoSinConvenio = 1;
      }

      if (
        (this.importeAnticipoAmortizadoTotal)
        >= this.getImporteTotalAnticipoContratos) {
        this.estimacion.importeCostoFinancieroAmortizacionAnticipo = 0;
        return;
      }

      let importeAmortizadoAnticipoFinanziado = 0;
      // Calcular la amoritzacion de importe del anticipo financiado
      importeAmortizadoAnticipoFinanziado = this.$numberRound((
        ((this.getImporteTotalAnticipoContratadoFinanciado
        * porcentajeAvanceFinancieroAcumuladoSinConvenio) - this
          .mixImporteCostoFinancieroAmortizacionAnticipoAnterior)
      ));

      // si es la estimacion finiquito realizar la resta con el faltante
      if (esEstimacionFiniquito || this.amortizarAnticipo) {
        importeAmortizadoAnticipoFinanziado = this.$numberRound(
          (this.getImporteTotalAnticipoContratadoFinanciado
          - this.mixImporteCostoFinancieroAmortizacionAnticipoAnterior),
        );
      }

      this.estimacion
        .importeCostoFinancieroAmortizacionAnticipo = importeAmortizadoAnticipoFinanziado;
      this.estimacion.importeCostoFinancieroEstimacion = (importeCostoFinanciero
        - importeAmortizadoAnticipoFinanziado);
    },
  },
  computed: {
    mixImporteCostoFinancieroAmortizacionAnticipoAnterior() {
      const estimaciones = this.estimaciones
        .filter(({ numero }) => numero < this.estimacion.numero);
      return this.$ObjSumar(estimaciones, 'importeCostoFinancieroAmortizacionAnticipo');
    },
  },
};
